import { useState } from "react";

import ExpandingContainer from "./ExpandingContainer";

import {
  Footer,
  MainContainer,
  Navbar,
  StepContainer,
  StepNumber,
  AppStoreLinks,
  JLRContainer,
  NextStepsContainer,
  CurvelogoContainer
} from "./styles";

import digiseqLogo from "./img/digiseq-logo.png";
import payAnyWhereImage from "../../assets/pay-anywhere-image.png";
import appStoreLogo from "./img/app-store.svg";
import gplayLogo from "./img/play-store.svg";
import jlrLogo from "./img/jlr-logo.png";
import curveLogo from "./img/curve_logo.png";
import euFlag from "./img/eu-flag.png";
import ukFlag from "./img/uk-flag.png";
const JLR2025 = () => {
  const [expandSection, setExpandSection] = useState({
    digiseq: false
  });

  const appStoreLinks = (appStoreUrl, playStoreUrl) => {
    return (
      <AppStoreLinks>
        <img
          src={appStoreLogo}
          alt="app-store"
          onClick={() => window.open(appStoreUrl, "_blank")}
        />
        <img
          src={gplayLogo}
          alt="play-store"
          onClick={() => window.open(playStoreUrl, "_blank")}
        />
      </AppStoreLinks>
    );
  };

  return (
    <MainContainer>
      <Navbar>
        <img src={jlrLogo} alt="jlr" />
      </Navbar>
      <JLRContainer>
        <h1>Welcome</h1>
        <p>
          {
            "Congratulations on becoming the wearer of the world's first NFC smart nail powered by Infineon, Smart Chip and DIGISEQ. Try this new payment method now."
          }
        </p>
      </JLRContainer>

      <ExpandingContainer customColor="#246FB0" title={"Infineon"}>
        <p>
          {
            "Explore how Infineon’s technologies are shaping the future of payments."
          }
        </p>
        <a
          href="https://www.infineon.com/cms/en/applications/security-solutions/payment-solutions/"
          target="_blank"
          rel="noreferrer"
        >
          Learn more
        </a>
      </ExpandingContainer>
      <ExpandingContainer customColor="#FF6400" title={"DIGISEQ"}>
        <p>
          {
            "DIGISEQ is an award-winning IoT service platform that securely provisions data into everyday wearables; enabling items, from rings to clothing, to deliver NFC payment, customer engagement functionality, access control and digital identity. We connect the ecosystem, serving as a centrepiece between banks, product creators, chip manufacturers and card bureaux, so that wearables can be simply and securely delivered into the hands of consumers."
          }
        </p>
        {!expandSection.digiseq && (
          <p
            className="show-more"
            onClick={() =>
              setExpandSection((sections) => ({
                ...sections,
                digiseq: !sections.digiseq
              }))
            }
          >
            show more
          </p>
        )}
        {expandSection.digiseq && (
          <>
            <p>
              <strong>Delivering the highest level of Security</strong>
            </p>
            <p>
              DIGISEQ’s RCOS™ over-the-air mobile personalisation and
              tokenisation service is leading the way in adopting the new SCP03
              standard, ensuring all provisioned payment data is fully protected
              to the highest available standards, while continuing to deliver
              the fastest self-provisioning service in the industry. SCP03
              protocol supports AES (Advanced Encryption Standard) based
              cryptography in lieu of TDEA (Triple Data Encryption Algorithm).
              The protocol protects bidirectional communication between the host
              and cards, mobile wallets and wearables.
            </p>
            <p>
              We also adhere to PSD2 directive for consumer initiated electronic
              payments, which mandates two factor authentication outside of the
              normal card present exemptions. With the support of online PIN, a
              transaction that exceeds the local contactless value or
              consecutive/cumulative transaction limit, will prompt the terminal
              to request the customer to enter the PIN (of the original card)
              therefore providing the exact same user experience as that of a
              card transaction.
            </p>
          </>
        )}
        {expandSection.digiseq && (
          <p
            className="show-more"
            onClick={() =>
              setExpandSection((sections) => ({
                ...sections,
                digiseq: !sections.digiseq
              }))
            }
          >
            show less
          </p>
        )}
      </ExpandingContainer>
      <ExpandingContainer customColor="#000000" title={"Smart Chip"}>
        <p>
          {
            "Smart Chip, powered by DIGISEQ, has developed, and patented the world’s first NFC manicure with an RFID chip and is preparing to launch in 2024. The Smart Chip is applied to your nail at an affiliated salon. With your Smart Chip you embody embedded finance. Link your nail to your payment card using Smart Chip mobile app and you're ready to go."
          }
        </p>
      </ExpandingContainer>
      <NextStepsContainer>
        <h2>Payment Account</h2>
        <ExpandingContainer
          customColor="#fff"
          title={"Link your card"}
          titleColor="#000"
        >
          <CurvelogoContainer>
            <img className="curve-logo" src={curveLogo} alt="curve logo" />
            <div className="flags">
              <img src={euFlag} alt="eu flag" />{" "}
              <img src={ukFlag} alt="uk flag" />
            </div>
          </CurvelogoContainer>
          <StepContainer>
            <StepNumber>1</StepNumber>
            <h2>Create a Curve Account</h2>
            <p>
              Register your card details with Curve to receive a free compatible
              digital bank card.
            </p>
            <p>Download the Curve App:</p>
            {appStoreLinks(
              "https://apps.apple.com/gb/app/curve-supercharge-your-money/id1049397112",
              "https://play.google.com/store/apps/details?id=com.imaginecurve.curve.prd"
            )}
          </StepContainer>
          <StepContainer>
            <StepNumber>2</StepNumber>
            <h2>Link Your Curve Virtual Card Using the Manage-Mii App</h2>
            <p>
              Follow the instructions on the Manage-Mii app and use your new
              Curve Card details when prompted.
            </p>
            {appStoreLinks(
              "https://apps.apple.com/app/manage-mii/id6446908503",
              "https://play.google.com/store/apps/details?id=com.digiseq.managemii"
            )}
          </StepContainer>
          <StepContainer>
            <StepNumber>3</StepNumber>
            <h2>Pay Anywhere!</h2>
            <p>
              Tap your wearable at any card terminal where Mastercard
              Contactless is enabled.
            </p>
            <img
              className="pay-anywhere"
              src={payAnyWhereImage}
              alt="pay anywhere"
            />
          </StepContainer>
        </ExpandingContainer>
      </NextStepsContainer>
      <Footer>
        <p className="powered-by">Powered by</p>
        <img src={digiseqLogo} alt="digiseq" />
        <p>Privacy Policy</p>
        <p>Terms & Conditions</p>
      </Footer>
    </MainContainer>
  );
};

export default JLR2025;
